import { ReduxService } from 'dashboard-services/services';

import { basicPipelineCreatorActions, builderPipelineCreatorActions } from 'actions/modules/datascience';

export const builderInitialState = {
  links: [], // links between the tasks
  positions: {},
  selectedTasks: undefined,
  footerSelectedTask: undefined,
  tasks: {}, // array of tasks - not fully filled - see Task.js from api
  initTasks: {},
  initLinks: [],

  doubleClickedTask: undefined,
  markdownFile: undefined,
  comments: [],

  activePortType: undefined,
  activePortIsInput: undefined,
  activeNodeId: undefined,

  backupTasks: [],
  recursionObjs: [],
  hasWarehouseAccess: undefined,
  shouldHaveWarehouseAccess: undefined,
}

export default (state = builderInitialState, action) => {
  switch (action.type) {
    case builderPipelineCreatorActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case builderPipelineCreatorActions.ADD_TASK:
      return ReduxService.updateObject(state, { tasks: ReduxService.updateObject(state.tasks, { [action.nodeId]: action.task }) })
    case builderPipelineCreatorActions.SET_TASK_FOR_REDO:
      return ReduxService.updateObject(state, { backupTasks: state.backupTasks.add(action.task) })
    case builderPipelineCreatorActions.REMOVE_TASK: {
      const tasks = ReduxService.updateObject(state.tasks, {})
      const positions = ReduxService.updateObject(state.positions, {})
      delete tasks[action.nodeId]
      delete positions[action.nodeId]
      return ReduxService.updateObject(state, { tasks, positions })
    }
    case builderPipelineCreatorActions.SELECT_TASKS:
      return ReduxService.updateObject(state, { selectedTasks: action.tasks, footerSelectedTask: action?.tasks?.length === 1 || !action?.tasks ? action.tasks?.[0] : state.footerSelectedTask })
    case builderPipelineCreatorActions.CLEAR_FOOTER_SELECTION:
      return ReduxService.updateObject(state, { footerSelectedTask: undefined })
    case builderPipelineCreatorActions.DOUBLE_CLICK_TASK:
      return ReduxService.updateObject(state, { doubleClickedTask: action.nodeId, footerSelectedTask: action.nodeId })
    case builderPipelineCreatorActions.CONNECT_TASKS:
      return ReduxService.updateObject(state, { links: state.links.add(action.link), activePortType: undefined, activePortIsInput: undefined })
    case builderPipelineCreatorActions.DISCONNECT_TASKS: {
      const links = state.links.filter(link => link.id !== action.id)
      return ReduxService.updateObject(state, { links })
    }
    case builderPipelineCreatorActions.ADD_CONNECTIONS:
      return ReduxService.updateObject(state, { links: state.links.concat(action.links || []) })
    case builderPipelineCreatorActions.CHANGE_TASK:
      return ReduxService.updateObject(state, { tasks: ReduxService.updateObject(state.tasks, { [action.nodeId]: action.task }) })
    case builderPipelineCreatorActions.CHANGE_TASK_PROP: {
      if(state.tasks[action.nodeId] && state.tasks[action.nodeId][action.name] !== action.value) {
        return ReduxService.updateObject(state, { tasks: ReduxService.updateObject(state.tasks, { [action.nodeId]: ReduxService.updateObject(state.tasks[action.nodeId], { [action.name]: action.value }) }) })
      }
      return state;
    }
    case builderPipelineCreatorActions.SAVE_TEMP_TITLE: 
      return ReduxService.updateObject(state, { tasks: ReduxService.updateObject(state.tasks, { [action.nodeId]: ReduxService.updateObject(state.tasks[action.nodeId], { readableName: state.tasks[action.nodeId]?.tempReadableName || state.tasks[action.nodeId]?.readableName, tempReadableName: state.tasks[action.nodeId]?.tempReadableName || state.tasks[action.nodeId]?.readableName }) }) })
    case builderPipelineCreatorActions.CHANGE_POSITION: {
      if(state.positions[action.nodeId]?.x !== action.position?.x || state.positions[action.nodeId]?.y !== action.position?.y) {
        return ReduxService.updateObject(state, { positions: ReduxService.updateObject(state.positions, { [action.nodeId]: { x: action.position.x, y: action.position.y } }) })  
      }
      return state;
    }
    case builderPipelineCreatorActions.CHANGE_POSITIONS:
      return ReduxService.updateObject(state, { positions: ReduxService.updateObject(state.positions, action.positions) })
    case builderPipelineCreatorActions.CHANGE_TASK_PARAM: {
      const task = state.tasks[action.nodeId],
            paramIndex = (task.params || []).findIndex(p => p.name === action.name)
      if(task.params[paramIndex].value !== action.value) {
        return ReduxService.updateObject(state, { tasks: ReduxService.updateObject(state.tasks, { [action.nodeId]: ReduxService.updateObject(state.tasks[action.nodeId], { params: state.tasks[action.nodeId].params.updateInList({ value: action.value }, paramIndex) }) }) })
      }
      return state;
    }
    case builderPipelineCreatorActions.CHANGE_MARKDOWN:
      return ReduxService.updateObject(state, { markdownFile: action.value })
    case builderPipelineCreatorActions.ADD_COMMENT: 
    return ReduxService.updateObject(state, { comments: state.comments.add({
      author: action.userName,
      id: action.id,
      text: "",
      position: action.position
    }) })
    case builderPipelineCreatorActions.SET_COMMENTS:
      return ReduxService.updateObject(state, { comments: action.comments || [] })
    case builderPipelineCreatorActions.CHANGE_COMMENT: {
      const index = state.comments.findIndex(i => i.id === action.id)
      return ReduxService.updateObject(state, { comments: state.comments.updateInList({ [action.name]: action.value }, index) })
    }
    case builderPipelineCreatorActions.REMOVE_COMMENT:
      return ReduxService.updateObject(state, { comments: state.comments.removeByProp("id", action.id) })
    case builderPipelineCreatorActions.SET_ACTIVE_PORT:
      return ReduxService.updateObject(state, { activePortType: action.activeType, activePortIsInput: action.input, activeNodeId: action.id })
    case basicPipelineCreatorActions.CLEAN_ALL:
      return builderInitialState;
    default:
      return state;
  }
}
